import { gql } from '@apollo/client';

// export const FETCH_CATEGORIES_BY_GROUP_ID = gql`
//     query FetchCategoriesByGroupId($group_id:String!) {
//     fetchCategoriesByGroupId(group_id: $group_id) {
//         data {
//             categories {
//                 id
//                 name
//                 description
//                 group_id
//                 folder_id
//             }
//         }
//         error {
//             message
//         }
//     }
// }
// `;

export const FETCH_CATEGORIES_BY_GROUP_ID = gql`
   query FetchCategoriesByGroupId($group_id:UUID!) {
    fetchCategoriesByGroupId(group_id: $group_id) {
        data {
            categories {
                created_at
                description
                folder_id
                group_id
                category_order
                id
                name
                updated_at
                category_order
                group {
                    created_at
                    description
                    folder_id
                    group_order
                    id
                    name
                    updated_at
                }
            }
        }
        error {
            code
            field
            message
        }
    }
}
`;


